import React from 'react';
import {
	makeStyles,
	TableHead,
	TableRow,
} from '@material-ui/core';
import { useCommentsContext } from '@components/CaseDetails/CommentsSection/CommentsContext/CommentsContext';
import { SortableCaseCommentFields } from '@data/caseComments/types/CaseComments.types';
import { TableSortableHeadCell } from '@components/TableSortableHeadCell/TableSortableHeadCell';
import {
	useCaseDetailsPageContext
} from '@components/CaseDetails/CaseDetailsContext/CaseDetailsPageContext/CaseDetailsPageContext';

const useStyles = makeStyles({
	condensed: {
		'position': 'sticky',
		'top': 0,
		'& > tr > th': {
			width: '33%',
		}
	},
	expanded: {
		'& > tr > th:nth-of-type(1)': { width: '15%' },
		'& > tr > th:nth-of-type(2)': { width: '15%' },
		'& > tr > th:nth-of-type(3)': { width: '15%' },
		'& > tr > th:nth-of-type(4)': { width: 'auto' },
		'& > tr > th:nth-of-type(5)': { width: '5%' },
	},
});

interface HeaderCell {
	sortableFieldName?: SortableCaseCommentFields;
	label: string;
	ariaLabel?: string;
}

const headCellsCondensed: HeaderCell[] = [
	{
		sortableFieldName: 'createdDateTime',
		label: 'Date',
		ariaLabel: 'Date',
	},
	{
		sortableFieldName: 'typesDisplay',
		label: 'Comment Type',
		ariaLabel: 'Comment Type',
	},
	{
		sortableFieldName: 'commenterDisplay',
		label: 'Commenter',
		ariaLabel: 'Commenter',
	},
];

const headCellsExpanded: HeaderCell[] = [
	...headCellsCondensed,
	{
		label: 'Comments',
		ariaLabel: 'Comments',
	},
	{
		label: '',
		ariaLabel: 'Actions',
	}
];

export const CommentsTableHeader = () => {
	const classes = useStyles();
	const { sortOrder, orderBy, handleSortComments } = useCommentsContext();
	const { showCondensedView } = useCaseDetailsPageContext();
	const headCells = showCondensedView ? headCellsCondensed : headCellsExpanded;

	return (
		<TableHead className={showCondensedView ? classes.condensed : classes.expanded}>
			<TableRow>
				{headCells.map((headCell) => (
					<TableSortableHeadCell<SortableCaseCommentFields>
						key={headCell.label}
						headCell={headCell}
						sortOrder={sortOrder}
						orderBy={orderBy}
						handleSortComments={handleSortComments}
					/>
				))}
			</TableRow>
		</TableHead>
	);
};
